var CommissionStatusColor;
(function (CommissionStatusColor) {
    CommissionStatusColor["PN"] = "5CB85C";
    CommissionStatusColor["PR"] = "AFAFAF";
    CommissionStatusColor["ON"] = "D9534F";
    CommissionStatusColor["VO"] = "5BC0DE";
})(CommissionStatusColor || (CommissionStatusColor = {}));

var ContrastColor;
(function (ContrastColor) {
    ContrastColor["White"] = "white";
    ContrastColor["Black"] = "black";
})(ContrastColor || (ContrastColor = {}));

export { CommissionStatusColor as C, ContrastColor as a };
//# sourceMappingURL=contrastColor-eea6b37b.js.map
